import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiErrorMessage } from "./helpers/apiErrorMessage";

function Users() {
    const [query, setQuery] = useState('');
    const [userList, setUserList] = useState([]);
    const [warning, setWarning] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => { fetchUsers(); }, []);

    const fetchUsers = async () => {
        try {
            setError(null);
            const response = await axios.get(`/api/admin/users`);
            setUserList(response.data);
        } catch (error) {
            setError(getApiErrorMessage(error, 'load users'));
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (index, userId) => {
        try {
            setError(null);
            const response = await axios.delete(`/api/admin/users/${userId}`);
            console.log(response.data.message);

            const updatedUserList = [...userList];
            updatedUserList.splice(index, 1);
            setUserList(updatedUserList);  // change at the frontend
        } catch (error) {
            setError(getApiErrorMessage(error, 'delete this user'));
            console.error("Error deleting user: ", error);
        }
    }

    if (loading) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Loading...</div>;
    }

    return (
        <div className="bg-gray-900 text-white font-sans min-h-screen">
        {error && (
            <div className="bg-red-900 border-l-4 border-red-600 p-4 m-4 rounded">
                <div className="flex justify-between items-center">
                    <p className="text-red-200">{error}</p>
                    <button onClick={() => setError(null)} className="text-red-400 hover:text-red-200 text-2xl">×</button>
                </div>
            </div>
        )}
        <div className="px-4 sm:px-6 md:px-10 lg:px-40">
            <div className="flex flex-col items-center w-full">
                <div className="flex items-center w-full max-w-xl">
                    <input
                        type="text"
                        placeholder="Search User"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        className="flex-grow bg-gray-700 text-gray-300 p-2 mb-5 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                </div>
            </div>

            <div className="mt-6 w-full">
                {userList
                    .filter(entry => entry.username.toLowerCase().includes(query.toLowerCase()))
                    .map((entry, index) => (
                        <div key={index} className="flex flex-col hover:bg-gray-800 transition-colors duration-200">
                            <div
                                className="flex flex-col sm:flex-row items-start sm:items-center border-t border-gray-700 py-4 px-4 gap-2 sm:gap-0">
                                <div className="text-gray-500 text-base sm:ml-8">{entry.userId}</div>
                                <div className="sm:ml-3 flex-grow flex flex-col">
                                    <span className="font-bold text-lg">{entry.username}</span>
                                    <p className="text-gray-400 text-sm">{entry.role}</p>
                                </div>
                                {entry.role === "user" && (
                                    <div className="flex mr-2">
                                        <i
                                            className="fas fa-trash-alt p-1 text-gray-500 bg-transparent rounded hover:bg-red-100 hover:text-red-600"
                                            onClick={() => setWarning(warning === index ? null : index)}
                                        ></i>
                                    </div>
                                )}
                            </div>

                            <div
                                className={`overflow-hidden transition-all duration-1000 ease-in-out ${warning === index ? 'h-20' : 'h-0'}`}>
                                {warning === index && (
                                    <div className="flex items-start space-x-20">
                                        <p className="flex items-start space-x-20 ml-28 mb-4 text-gray-300 space-y-1">The action is irreversible! Are you sure you want to delete this user forever?</p>
                                        <i className="fas fa-trash-alt p-1 text-gray-500 bg-transparent rounded hover:bg-red-100 hover:text-red-600 mr-2"
                                           onClick={() => handleDelete(index, entry.userId)}></i>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
        </div>
    )
}

export default Users;